export default __webpack_public_path__ + "static/videoN2-6b2f0ae5a8a9ec126e6898fb7d688f8b.webp";